import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.notifications');
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-notifications',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.notifications/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.notifications-page,
.notifications-page *,
.notifications-page *::before,
.notifications-page *::after {
  box-sizing: border-box;
}

.notifications-page {
  min-height: 100vh;
  min-height: 100dvh;
  padding: 30px 38px 46px;
  color: #172033;
  background: radial-gradient(circle at 7% 0%, rgba(124, 58, 237, 0.09), transparent 27%), radial-gradient(circle at 93% 8%, rgba(244, 114, 182, 0.07), transparent 24%), linear-gradient(180deg, #fbfaff 0%, #f7f6fa 100%);
}

button {
  font: inherit;
}

.page-header,
.notification-content {
  width: 100%;
  max-width: 1180px;
  margin-right: auto;
  margin-left: auto;
}

.page-header {
  display: flex;
  min-height: 82px;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  margin-bottom: 24px;
}

.eyebrow {
  margin: 0 0 7px;
  color: #7c3aed;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.13em;
}

.page-header h1 {
  margin: 0;
  color: #111827;
  font-size: clamp(25px, 2.2vw, 31px);
  font-weight: 900;
  letter-spacing: -0.04em;
}

.header-copy {
  margin: 8px 0 0;
  color: #7c8494;
  font-size: 13px;
}

.header-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;
}

.unread-summary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #667085;
  font-size: 11px;
  font-weight: 800;
}

.unread-summary i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #8b5cf6;
  box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.1);
}

.read-all-button,
.load-more-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #ddd6fe;
  color: #6d28d9;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  background: #fff;
  transition: transform 150ms ease, border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.read-all-button {
  min-height: 40px;
  padding: 0 14px;
  border-radius: 11px;
  box-shadow: 0 8px 20px rgba(71, 42, 122, 0.06);
}

.read-all-button svg {
  width: 15px;
  height: 15px;
}

.read-all-button:hover,
.load-more-button:hover:not(:disabled) {
  border-color: #c4b5fd;
  background: #faf8ff;
  transform: translateY(-1px);
}

.notification-content {
  display: grid;
}

.notification-panel {
  min-height: 410px;
  padding: 22px;
  border: 1px solid rgba(228, 222, 238, 0.82);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 14px 38px rgba(61, 43, 88, 0.06);
}

.panel-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 16px;
}

.panel-heading h2 {
  margin: 0;
  color: #172033;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: -0.025em;
}

.panel-heading p {
  margin: 6px 0 0;
  color: #8a94a6;
  font-size: 11px;
}

.total-badge {
  flex: 0 0 auto;
  padding: 6px 9px;
  border-radius: 999px;
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
  background: #f5f3ff;
}

.notification-list {
  display: grid;
  gap: 8px;
}

.notification-row {
  position: relative;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: center;
  gap: 13px;
  width: 100%;
  min-height: 82px;
  padding: 12px 14px;
  border: 1px solid #eeeaf4;
  border-radius: 14px;
  color: inherit;
  text-align: left;
  cursor: pointer;
  background: #fff;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease, background 160ms ease;
}

.notification-row:hover {
  border-color: #d8cef0;
  box-shadow: 0 9px 24px rgba(64, 43, 98, 0.07);
  transform: translateY(-1px);
}

.notification-row.unread {
  border-color: rgba(196, 181, 253, 0.62);
  background: linear-gradient(90deg, rgba(245, 243, 255, 0.94), #fff 44%);
}

.unread-dot {
  position: absolute;
  top: 14px;
  left: 8px;
  width: 7px;
  height: 7px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #7c3aed;
  box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.12);
}

.notification-icon {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
}

.notification-icon svg {
  width: 20px;
  height: 20px;
}

.notification-copy {
  min-width: 0;
}

.notification-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.notification-title-row strong {
  min-width: 0;
  overflow: hidden;
  color: #172033;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notification-title-row time {
  flex: 0 0 auto;
  color: #a0a7b5;
  font-size: 10px;
  font-weight: 700;
}

.notification-message {
  display: block;
  margin-top: 4px;
  color: #667085;
  font-size: 12px;
  line-height: 1.55;
}

.notification-link {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-top: 7px;
  color: #7c3aed;
  font-size: 10px;
  font-weight: 900;
}

.notification-link svg {
  width: 12px;
  height: 12px;
}

.loading-state,
.empty-state {
  display: flex;
  min-height: 300px;
  align-items: center;
  justify-content: center;
}

.loading-state {
  flex-direction: column;
  gap: 12px;
  color: #98a2b3;
  font-size: 12px;
}

.loading-state p,
.empty-state p {
  margin: 0;
}

.spinner,
.button-spinner {
  border: 2px solid #ede9fe;
  border-top-color: #7c3aed;
  border-radius: 50%;
  animation: notification-spin 700ms linear infinite;
}

.spinner {
  width: 28px;
  height: 28px;
}

.empty-state {
  flex-direction: column;
  padding: 28px;
  text-align: center;
}

.empty-icon {
  display: grid;
  place-items: center;
  width: 58px;
  height: 58px;
  border-radius: 17px;
  color: #8b5cf6;
  background: #f3efff;
}

.empty-icon svg {
  width: 25px;
  height: 25px;
}

.empty-state h3 {
  margin: 15px 0 6px;
  color: #172033;
  font-size: 15px;
  font-weight: 900;
}

.empty-state p {
  color: #8a94a6;
  font-size: 12px;
}

.load-more-wrap {
  display: flex;
  justify-content: center;
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid #f0edf5;
}

.load-more-button {
  min-width: 148px;
  min-height: 40px;
  padding: 0 16px;
  border-radius: 11px;
}

.load-more-button:disabled {
  cursor: wait;
  opacity: 0.65;
}

.button-spinner {
  width: 14px;
  height: 14px;
}

@keyframes notification-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 760px) {
  .notifications-page {
    padding: 24px max(18px, env(safe-area-inset-right)) max(38px, env(safe-area-inset-bottom)) max(18px, env(safe-area-inset-left));
  }
  .page-header {
    min-height: auto;
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 20px;
  }
  .header-actions {
    width: 100%;
    justify-content: space-between;
  }
  .notification-panel {
    padding: 17px;
    border-radius: 16px;
  }
  .notification-row {
    grid-template-columns: 38px minmax(0, 1fr);
    gap: 11px;
    padding: 12px;
  }
  .notification-icon {
    width: 38px;
    height: 38px;
  }
  .notification-title-row {
    gap: 8px;
  }
  .notification-message {
    font-size: 11px;
  }
}
@media (max-width: 460px) {
  .header-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .read-all-button {
    width: 100%;
  }
  .panel-heading p {
    max-width: 220px;
  }
  .notification-title-row {
    display: block;
  }
  .notification-title-row time {
    display: block;
    margin-top: 3px;
  }
}`],
})
export class PageNotificationsComponent implements OnInit {
    public notifications: any[] = [];
    public unreadCount: number = 0;
    public total: number = 0;
    public page: number = 1;
    public readonly limit: number = 20;
    public loading: boolean = true;
    public loadingMore: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load(true);
    }

    public async load(reset: boolean = false) {
        if (reset) {
            this.page = 1;
            this.notifications = [];
            this.loading = true;
        } else {
            this.loadingMore = true;
        }
        await this.service.render();

        const { code, data } = await wiz.call('list', {
            page: this.page,
            limit: this.limit
        });
        if (code === 200) {
            const rows = data?.notifications || [];
            this.notifications = reset
                ? rows
                : [...this.notifications, ...rows];
            this.unreadCount = Number(data?.unread_count || 0);
            this.total = Number(data?.total || 0);
        }
        this.loading = false;
        this.loadingMore = false;
        await this.service.render();
    }

    public hasMore() {
        return this.notifications.length < this.total;
    }

    public async loadMore() {
        if (this.loadingMore || !this.hasMore()) return;
        this.page += 1;
        await this.load();
    }

    public async openNotification(notification: any) {
        if (!notification?.is_read) {
            const { code } = await wiz.call('mark_read', {
                id: notification.id
            });
            if (code === 200) {
                notification.is_read = true;
                this.unreadCount = Math.max(0, this.unreadCount - 1);
            }
        }
        await this.service.render();
        if (notification?.link) {
            await this.router.navigateByUrl(notification.link);
        }
    }

    public async markAllRead() {
        if (this.unreadCount === 0) return;
        const { code } = await wiz.call('mark_all_read');
        if (code === 200) {
            this.notifications = this.notifications.map(
                (notification: any) => ({
                    ...notification,
                    is_read: true
                })
            );
            this.unreadCount = 0;
            await this.service.render();
        }
    }

    public notificationTime(value: any) {
        const created = this.kstDate(value);
        if (isNaN(created.getTime())) return '';
        const seconds = Math.max(
            0,
            Math.floor((Date.now() - created.getTime()) / 1000)
        );
        if (seconds < 60) return '방금 전';
        if (seconds < 3600) return `${Math.floor(seconds / 60)}분 전`;
        if (seconds < 86400) return `${Math.floor(seconds / 3600)}시간 전`;
        if (seconds < 604800) return `${Math.floor(seconds / 86400)}일 전`;
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'Asia/Seoul'
        }).format(created);
    }

    private kstDate(value: any) {
        const raw = String(value || '').trim();
        if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/.test(raw)) {
            return new Date(`${raw.replace(' ', 'T')}+09:00`);
        }
        return new Date(value);
    }

    public notificationIconClass(eventType: string) {
        if ((eventType || '').startsWith('poll')) {
            return 'bg-amber-50 text-amber-600';
        }
        if (
            (eventType || '').startsWith('schedule')
            || eventType === 'itinerary_updated'
        ) {
            return 'bg-blue-50 text-blue-600';
        }
        if (eventType === 'meeting_deleted' || eventType === 'member_removed') {
            return 'bg-red-50 text-red-600';
        }
        return 'bg-violet-50 text-violet-600';
    }

    public isPoll(eventType: string) {
        return (eventType || '').startsWith('poll');
    }

    public isSchedule(eventType: string) {
        return (
            (eventType || '').startsWith('schedule')
            || eventType === 'itinerary_updated'
        );
    }

    public trackNotification(_: number, notification: any) {
        return notification.id;
    }
}

export default PageNotificationsComponent;